import {
  MODAL_INTERACTION,
  MODAL_HIDDEN,
  MODAL_DATA_LOADED,
} from '../actions/constants';
import { MODAL_ADD_DASHBOARD } from '../util/enums/EnumModals';
import ModalAddDashboard from '../components/modals/ModalAddDashboard';
import { DAILY } from '../util/enums/EnumDashboardRefreshFrequency';

function morning7am() {
  const dt = new Date();
  dt.setHours(7);
  dt.setMinutes(0);
  dt.setSeconds(0);
  dt.setMilliseconds(0);
  return dt.toISOString();
}

const INITIAL_STATE = {
  name: '',
  schedule: DAILY,
  time: morning7am(),
  existing: null, // DashboardRef or null if new dashboard
};

function interaction(state, payload) {
  switch (payload.section) {
    case 'nameChanged': {
      return { ...state, name: payload.newValue };
    }
    case 'timeChanged': {
      return { ...state, time: payload.newValue };
    }
    case 'changeSchedule': {
      return { ...state, schedule: payload.newValue };
    }

    default:
      return state;
  }
}

const modalAddWidget = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case MODAL_HIDDEN:
      return INITIAL_STATE; // reset modal
    case MODAL_DATA_LOADED: {
      if (action.payload.modal !== ModalAddDashboard) {
        return state;
      }
      if (!action.payload.dashboard) {
        // creating new dashboard
        return state;
      }
      return {
        ...state,
        name: action.payload.json._name,
        time: action.payload.json._time,
        schedule: action.payload.json._refreshFrequency,
        existing: action.payload.dashboard,
      };
    }
    case MODAL_INTERACTION: {
      if (action.payload.modalType !== MODAL_ADD_DASHBOARD) {
        return state;
      }
      const newState = interaction(state, action.payload.props);
      newState.readyForSave = newState.name.trim().length > 0;
      return newState;
    }
    default:
      return state;
  }
};

export default modalAddWidget;
